<template>
  <v-container fluid grid-list-md>
    <h2>{{explanation}}</h2>
    <v-layout v-for="patient in patients" :key="patient.ptSrNo">
      <v-flex md-3>
        <div>
          <label class="modal-label">Patient ID</label>
        </div>
        <v-text-field
          solo
          v-model="patient.ptID"
          :disabled="true"/>
      </v-flex>
      <v-flex md-3>
        <div>
          <label class="modal-label">Patient First Name</label>
        </div>
        <v-text-field
          solo
          v-model="patient.nameFirst"
          :disabled="true"/>
      </v-flex>
      <v-flex md-3>
        <div>
          <label class="modal-label">Patient Last Name</label>
        </div>
        <v-text-field
          solo
          v-model="patient.nameLast"
          :disabled="true"/>
      </v-flex>
      <v-flex md-3>
        <div>
          <label class="modal-label">Patient Date of Birth</label>
        </div>
        <v-text-field
          solo
          v-model="patient.dob"
          :disabled="true"/>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: "patientMergeInfo",
  props: {
    patients: Array
  },
  computed: {
    explanation(){
      if (this.patients.length > 1) 
        return "The following patients' demographic information exactly matches. Would you like to merge them together?";
      else 
        return "The following patient's demographic information exactly matches. Would you like to merge the two together?";
    }
  }
};
</script>